// extracted by mini-css-extract-plugin
export default {"userinputblog":"userinputblog_d57661dfc7a169207b55"};